import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  inlineLabels?: boolean;
  className?: string;
};

const FormItem = ({ children, inlineLabels, className }: PropsWithChildren<Props>) => (
  <div
    className={clsx({
      "form-item": true,
      "labels-inline": inlineLabels,
      [`${className ? className : ""}`]: className,
    })}
  >
    {children}
  </div>
);

export default FormItem;
